// src/redux/slices/auth.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: {
    name: '',
    email: '',
    role: null, // "admin" | "customer"
  },
  accessToken: '',
  saasToken: '',
  tenantId: '',
  currentLanguage: 'en',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, { payload }) {
      state.user = payload; // user details
    },
    setAccessToken(state, { payload }) {
      state.accessToken = payload; // JWT token
    },
    setSaasToken(state, { payload }) {
      state.saasToken = payload; // SAAS token
    },
    setUserRole(state, { payload }) {
      state.userRole = payload; // User Role
    },
    setTenantId(state, { payload: tenantId }) {
      state.tenantId = tenantId;
    },
    logout(state) {
      state.user = { name: '', email: '', role: null };
      state.accessToken = '';
    },
    setCurrentLanguage(state, { payload }) {
      state.currentLanguage = payload;
    },
  },
});

export const {
  setUser,
  setAccessToken,
  setSaasToken,
  setUserRole,
  clearAuth,
  setTenantId,
  setCurrentLanguage,
} = authSlice.actions;

export default authSlice.reducer;
